import { api as accountingApi } from "../api";
import { UploadedDocument, UploadedDocumentGetParams, UploadedDocumentUpdateParams } from "./types";

export const documentsApi = accountingApi.injectEndpoints({
    endpoints: (build) => ({
        getDocument: build.query<UploadedDocument, UploadedDocumentGetParams>({
            query: ({ accountId, documentId }) => ({
                url: `api/v1/accounting/${accountId}/uploaded_documents/${documentId}`,
            }),
        }),
        updateDocument: build.mutation<UploadedDocument, UploadedDocumentUpdateParams>({
            query: ({ accountId, documentId, data }) => ({
                url: `api/v1/accounting/${accountId}/uploaded_documents/${documentId}`,
                method: "PATCH",
                body: data,
            }),
        }),
    }),
});

export const { useGetDocumentQuery, useUpdateDocumentMutation } = documentsApi;
